import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import {
  Nav,
  Glyphicon,
  DropdownButton,
  Dropdown,
  MenuItem,
} from "react-bootstrap";
import UserInfoComponent from "../../views/cm-view/cm-menu-user-info-view";
import ConfirmationModal from "../../modal-views/confirmation-modal";
import { ToastContainer } from "react-toastify";
import ChangeSingleFieldValueModal from "../../modal-views/change-single-field-value-modal";
import { SearchBar } from "../search/SearchBar";
import { SearchFilters } from "../search/SearchFilters";
import HeaderItem from "./HeaderItem";
import ProfileOverlay from "./ProfileOverlay";
import { withRouter } from "../../utils/Utils";
import { CustomTooltip } from "../tooltip/CustomTooltip";
import { CustomToggle, CustomMenu } from "../dropdown/CustomDropdown";
import HttpUtils from "src/utils/HttpUtils";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject("userStore", "changeSingleFieldValueModalStore", "searchStore")
@observer
class Header extends React.Component {
  componentDidUpdate(prevProps) {
    const searchParams = this.props.location.search;
    if (searchParams && searchParams !== prevProps.location.search) {
      this.updateStoreWithQueryParams();
    }
  }

  updateStoreWithQueryParams = () => {
    const { location } = this.props;
    const {
      getCubeTypeOptions,
      setSelectedCubeTypes,
      getUserProfiles,
      setSelectedUserProfile,
    } = this.props.searchStore;
    const params = new URLSearchParams(location.search);
    const target = params.get("cubeTypes");
    if (!target) return;
    const selectedCubeTypes = target.split(",");
    let id;
    if (
      selectedCubeTypes.length === 4 &&
      selectedCubeTypes.includes("C") &&
      selectedCubeTypes.includes("D") &&
      selectedCubeTypes.includes("RC") &&
      selectedCubeTypes.includes("NRC")
    ) {
      id = "power";
    } else if (
      selectedCubeTypes.length === 3 &&
      selectedCubeTypes.includes("D") &&
      selectedCubeTypes.includes("RC") &&
      selectedCubeTypes.includes("NRC")
    ) {
      id = "business";
    } else if (selectedCubeTypes.length === 0) {
      id = "full";
    } else {
      id = "custom";
    }
    const profile = getUserProfiles.find((up) => up.id === id);
    if (!profile) return;
    setSelectedUserProfile(profile);
    const cubeTypes = getCubeTypeOptions.filter((cto) =>
      selectedCubeTypes.includes(cto.value)
    );
    setSelectedCubeTypes(cubeTypes.map((option) => option.value));
  };

  checkIfUserHasRole = (allowedRole) => {
    const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";
    const { userStore } = this.props;
    let showItem = true;
    if (allowedRole) {
      showItem = !IS_BIRD_APP && userStore.hasUserTheGivenRole(allowedRole);
    }
    return showItem;
  };

  render() {
    const { version, build, environment } = this.props.userStore;
    const { filtersVisible, getFrameworks } = this.props.searchStore;
    const apiDocumentationUrl = IS_BIRD_APP
      ? "documentation/api/v2/bird.html"
      : "documentation/api/v2/sdd.html";

    return (
      <React.Fragment>
        <Nav
          bsStyle="tabs"
          className={`ecb-app-header ${filtersVisible ? "showFilters" : ""}`}
          activeKey={null}
        >
          <React.Fragment>
            <li className="sdd-logo-navitem">
              <Link to="/">
                <img className="sdd-logo" src="/logo.png" alt="SDD logo" />
              </Link>
              <small>
                {`${environment()} v${version()}`}
                {`${environment() ? "-" + build() : ""}`}
              </small>
            </li>
            <li style={{ marginRight: "10px", flex: 1 }}>
              <SearchBar frameworks={getFrameworks} />
              <CustomTooltip type="Search" color="white" />
            </li>
            <li>
              <HeaderItem
                classname="sdd-logo-navitem"
                id="sdd-logo-navitem"
                name="ADVANCED SEARCH"
                link="/multisearch"
              />
            </li>
            <HeaderItem name="METADATA & EXPORTS" link="/cm" />
            <HeaderItem
              name="DICTIONARY ADMIN"
              link="/da"
              allowedRole="DICTIONARY_ADMINISTRATOR"
            />
            ,
            <HeaderItem
              name="PROJECT OWNER"
              link="/po"
              allowedRole="PROJECT_OWNER"
            />
            ,
            <HeaderItem
              name="MAINTENANCE AGENCY OWNER"
              link="/mao"
              allowedRole="MAINTENANCE_AGENCY_OWNER"
            />
            ,
            <HeaderItem
              name="SYSTEM ADMIN"
              link="/sa"
              allowedRole="SYSTEM_ADMINISTRATOR"
            />
            <DropdownButton
              bsStyle={"default"}
              title={"PAGES"}
              key={1}
              className="my-dropdown"
              id="my-dropdown-header"
            >
              {this.checkIfUserHasRole() && (
                <HeaderItem name="METADATA & EXPORTS" link="/cm" />
              )}
              {this.checkIfUserHasRole("DICTIONARY_ADMINISTRATOR") && (
                <HeaderItem
                  name="DICTIONARY ADMIN"
                  link="/da"
                  allowedRole="DICTIONARY_ADMINISTRATOR"
                />
              )}
              {this.checkIfUserHasRole("PROJECT_OWNER") && (
                <HeaderItem
                  name="PROJECT OWNER"
                  link="/po"
                  allowedRole="PROJECT_OWNER"
                />
              )}
              {this.checkIfUserHasRole("MAINTENANCE_AGENCY_OWNER") && (
                <HeaderItem
                  name="MAINTENANCE AGENCY OWNER"
                  link="/mao"
                  allowedRole="MAINTENANCE_AGENCY_OWNER"
                />
              )}
              {this.checkIfUserHasRole("SYSTEM_ADMINISTRATOR") && (
                <HeaderItem
                  name="SYSTEM ADMIN"
                  link="/sa"
                  allowedRole="SYSTEM_ADMINISTRATOR"
                />
              )}
            </DropdownButton>
            {HttpUtils.isThereAnyPendingRequest ? (
              <div className="pending-requests">
                <div className="nav-loader"></div>
                <div className="pending-requests-tooltip">
                  Pending Requests
                  <ul style={{ textAlign: "left" }}>
                    {HttpUtils.getPendingRequests.map((request, requestIndex) => (
                      <li key={requestIndex}>{request}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
            <li>
              <UserInfoComponent />
              {!this.props.userStore.isUserReaderOnly && (
                  <div style={{ marginRight: "10px" }}>
                    <Link to="/notification">
                      <Glyphicon glyph="bell" />
                    </Link>
                  </div>
                )
              }
              <ProfileOverlay container={this} location={this.props.location} />
            </li>
            <div className="help-icon">
              <Dropdown id="dropdown-custom-menu">
                <CustomToggle bsRole="toggle">
                  <Glyphicon glyph="question-sign" color="#eee" />
                </CustomToggle>

                <CustomMenu bsRole="menu">
                  <MenuItem eventKey="1" href="/userguide/index.html">
                    Help
                  </MenuItem>
                  <MenuItem eventKey="2" href={apiDocumentationUrl}>
                    API Documentation
                  </MenuItem>
                </CustomMenu>
              </Dropdown>
            </div>
            <SearchFilters />
          </React.Fragment>
        </Nav>

        {HttpUtils.computed_bool_isSpiner ? (
          <div id="ecb_appjs_spinner_element">
            <div className="loader"></div>
          </div>
        ) : null}

        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          style={{ zIndex: 9999, top: 50 }}
        />

        <ChangeSingleFieldValueModal />

        <ConfirmationModal />
      </React.Fragment>
    );
  }
}

export default withRouter(Header);
